import '../shared/logger';
import { initUtmTracking } from '../utils/utm/initUtmTracking';
export const WebAppLoggerInitializer = () => {
  initUtmTracking();
  return null;
};